// src/features/reports/wprPrint.js
//
// Shared print-to-PDF helpers used by the WPR report and the Projects
// Weekly Overview. One popup mechanism, one escaping rule.

/** Escape user/server strings before injecting into print HTML. */
export function escHtml(str) {
  if (str === null || str === undefined || str === "") return "";
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/**
 * Open a popup and write a self-contained print document into it.
 * Returns true on success, false when the popup was blocked.
 */
export function openPrintWindow(html, win = typeof window !== "undefined" ? window : null) {
  const popup = win?.open ? win.open("", "_blank") : null;
  if (!popup) return false;
  popup.document.write(html);
  popup.document.close();
  return true;
}

export const POPUP_BLOCKED_MESSAGE = "The print window was blocked. Allow pop-ups for this site and try again.";
